// use_AdminValidation.js
import * as Yup from "yup";

export const useAdminValidation = () => {
  const formValidation = (isEditing = false) => {
    return Yup.object({
      adminName: Yup.string().required("Name ist erforderlich"),
      email: Yup.string().email("Ungültige E-Mail").required("E-Mail ist erforderlich"),
      password: isEditing ? Yup.string().notRequired() : Yup.string().required("Passwort ist erforderlich"),
      passwordConfirm: isEditing
        ? Yup.string().notRequired()
        : Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwörter stimmen nicht überein")
            .required("Passwortbestätigung ist erforderlich"),
      role: Yup.string().required("Rolle ist erforderlich"),
    });
  };

  return { formValidation };
};
